import { Phone } from "lucide-react";
import Logo from "@/components/Logo";

const Header = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          <button 
            onClick={scrollToTop}
            className="flex items-center hover:opacity-80 transition-opacity"
            data-testid="logo-header"
            data-track="nav_logo"
            aria-label="Zur Startseite"
          >
            <Logo size="small" />
          </button>
          
          <a
            href="/anruf"
            className="flex items-center gap-2 bg-[#4A331D] text-white px-4 py-2 sm:px-6 sm:py-3 rounded-lg hover:bg-[#593B23] transition-colors font-medium text-sm sm:text-base shadow-md"
            data-testid="header-phone-button"
            data-track="phone_click"
            data-track-value="header"
          >
            <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
            <span className="hidden sm:inline">0176 20283482</span>
            <span className="sm:hidden">Anrufen</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;